import { Supplier, User } from "../types";

const normalize = (value?: string | null): string => (value || "").toLowerCase();

export const resolveStatsSupplierId = (
    supplier: Supplier | null | undefined,
    user: User | null | undefined,
): number | undefined => {
    // Приоритет: фактический supplier.id из API
    if (supplier?.id) return supplier.id;
    // Второй приоритет: supplierId пользователя
    if (user?.supplierId) return user.supplierId;

    const login = normalize(user?.login);
    if (login === "okko") return 1;
    if (login === "wink") return 2;
    if (login === "premiere" || login === "premier") return 3;

    const code = normalize(supplier?.code);
    const name = normalize(supplier?.name);
    if (code.includes("okko") || name.includes("okko")) return 1;
    if (code.includes("wink") || name.includes("wink")) return 2;
    if (code.includes("premier") || code.includes("premiere") || name.includes("premier") || name.includes("premiere")) return 3;

    return undefined;
};
